function getFlagEmoji(countryCode) {
  return countryCode.toUpperCase().split("").map((char) => String.fromCodePoint(127397 + char.charCodeAt(0))).join("");
}
if (!customElements.get("localization-section")) {
  customElements.define(
    "localization-section",
    class ExampleSection extends HTMLElement {
      dataEl;
      data;
      modal;
      modalContent;
      closeButton;
      lastFocusedElement = null;
      trapFocusHandler = null;
      constructor() {
        super();
        this.dataEl = this.querySelector("[data-section-data]");
        this.modal = this.querySelector("[data-localization]");
        this.modalContent = this.querySelector("[data-localization-content]");
        this.closeButton = this.querySelector("[data-close-localization]");
        this.data = this.dataEl?.textContent ? JSON.parse(this.dataEl.textContent) : { localizationAnabled: false };
      }
      buildTrapFocusHandler() {
        const sel = [
          "a[href]",
          "button:not([disabled])",
          "input:not([disabled])",
          "select:not([disabled])",
          "textarea:not([disabled])",
          '[tabindex]:not([tabindex="-1"])'
        ].join(", ");
        return (e) => {
          if (e.key !== "Tab") return;
          const focusable = Array.from(
            this.modal.querySelectorAll(sel)
          ).filter((el) => !el.closest("[hidden]"));
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (!this.modal.contains(document.activeElement)) {
            e.preventDefault();
            first.focus();
            return;
          }
          if (e.shiftKey) {
            if (document.activeElement === first) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        };
      }
      // Show the modal
      showModal(trigger) {
        if (this.modal && this.modalContent) {
          this.lastFocusedElement = trigger || document.activeElement;
          document.body.classList.add("overflow-hidden");
          this.modal.classList.remove("hidden");
          this.modal.classList.add("flex");
          this.modalContent.classList.remove("scale-out");
          this.modalContent.classList.add("scale-in");
          requestAnimationFrame(() => {
            const heading = this.modal.querySelector('h2[tabindex="-1"]');
            (heading || this.modalContent).focus();
          });
          this.trapFocusHandler = this.buildTrapFocusHandler();
          document.addEventListener("keydown", this.trapFocusHandler);
        }
      }
      // Hide the modal
      hideModal() {
        if (this.modal && this.modalContent) {
          document.body.classList.remove("overflow-hidden");
          this.modalContent.classList.remove("scale-in");
          this.modalContent.classList.add("scale-out");
          if (this.trapFocusHandler) {
            document.removeEventListener("keydown", this.trapFocusHandler);
            this.trapFocusHandler = null;
          }
          setTimeout(() => {
            if (this.modal) {
              this.modal.classList.add("hidden");
              this.modal.classList.remove("flex");
            }
            this.lastFocusedElement?.focus();
            this.lastFocusedElement = null;
          }, 300);
        }
      }
      // Add flags
      updateFlagsInUI() {
        if (!this.modal) return;
        const selectElement = this.modal.querySelector("[data-localization-country-select]");
        if (selectElement) {
          Array.from(selectElement.options).forEach((option) => {
            const countryCode = option.value;
            const countryName = option.getAttribute("data-localization-country-name") || "";
            option.textContent = `${getFlagEmoji(countryCode)} ${countryName}`;
          });
        }
        const localizationButtons = document.querySelectorAll("[data-open-localization]");
        if (localizationButtons.length) {
          localizationButtons.forEach((button) => {
            const countryCode = button.getAttribute("data-localization-country-code");
            if (countryCode) {
              const flagTarget = button.querySelector("[data-localization-flag]");
              const flagEmoji = getFlagEmoji(countryCode);
              if (flagTarget) {
                flagTarget.textContent = flagEmoji;
              } else {
                button.textContent = flagEmoji;
              }
            }
          });
        }
        const localizationFlagElements = this.modal.querySelectorAll("[data-localization-store-flag]");
        if (localizationFlagElements.length) {
          localizationFlagElements.forEach((element) => {
            const countryCode = element.getAttribute("data-localization-store-flag");
            if (countryCode) {
              element.textContent = getFlagEmoji(countryCode);
            }
          });
        }
      }
      closeOnOverlayClick(event) {
        if (event.target === this.modal) {
          this.hideModal();
        }
      }
      init() {
        if (!this.data.localizationAnabled) return;
        this.updateFlagsInUI();
        const openButtons = document.querySelectorAll("[data-open-localization]");
        openButtons.forEach((button) => {
          button.addEventListener("click", () => this.showModal(button));
        });
        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && this.modal && !this.modal.classList.contains("hidden")) {
            this.hideModal();
          }
        });
        this.closeButton?.addEventListener("click", () => this.hideModal());
        this.modal?.addEventListener("click", (event) => this.closeOnOverlayClick(event));
      }
      // Lifecycle callback when the element is connected to the DOM
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {
        const openButtons = document.querySelectorAll("[data-open-localization]");
        openButtons.forEach((button) => {
          button.removeEventListener("click", () => this.showModal());
        });
        this.closeButton?.removeEventListener("click", () => this.hideModal());
        this.modal?.removeEventListener("click", (event) => this.closeOnOverlayClick(event));
      }
    }
  );
}
